import { differenceInCalendarDays } from 'date-fns';
import { ExtendedWorkspace, Action } from '@/lib/types';

type PreventDefault = Pick<React.FormEvent, 'preventDefault'>['preventDefault'];
type StopPropagation = Pick<React.FormEvent, 'stopPropagation'>['stopPropagation'];

export function preventNativeSubmit<
  T extends {
    preventDefault: PreventDefault;
    stopPropagation: StopPropagation;
  },
>(callback: any) {
  return function (e: T) {
    e.preventDefault();
    e.stopPropagation();
    callback(e);
  };
}

export function calculateTotalCount(actions: Action[]) {
  return actions.reduce((accumulator, item) => accumulator + item.cnt, 0);
}

export function totalDays(endDate: string) {
  return differenceInCalendarDays(endDate, Date.now());
}

export const ymdRegex = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;

export const datetimeRegex =
  /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(\.\d+)?(Z|[+-][01]\d:[0-5]\d)?$/;

export function disabledProps(disabled?: boolean) {
  return disabled ? { isDisabled: true, cursor: 'not-allowed' } : {};
}

export function orderWorkspaces(workspaces: ExtendedWorkspace[], workspaceId: string) {
  return workspaces.sort((a, b) => {
    if (a.id === parseInt(workspaceId, 10)) return -1;
    if (b.id === parseInt(workspaceId, 10)) return 1;
    return 0;
  });
}

export function checkBaseContentType(baseContentTypeId: number, contentTypeId: number): boolean {
  return baseContentTypeId === contentTypeId;
}
